/**
 * Feature imports + tree. Login plus dashboard, area, sector, stock (AD-9),
 * and the stock drill-downs Chart Terminal + Technical Analysis.
 */
import { createRouter } from '@tanstack/react-router';

import { areaRoute } from '@/features/area/route';
import { chartTerminalRoute } from '@/features/chart-terminal/route';
import { dashboardRoute } from '@/features/dashboard/route';
import { loginRoute } from '@/features/login/route';
import { sectorRoute } from '@/features/sector/route';
import { stockRoute } from '@/features/stock/route';
import { technicalRoute } from '@/features/technical/route';
import { stringifyNavSearch } from '@/lib/nav/search';

import { rootRoute } from './router-root';

const routeTree = rootRoute.addChildren([
  dashboardRoute,
  areaRoute,
  sectorRoute,
  stockRoute,
  chartTerminalRoute,
  technicalRoute,
  loginRoute,
]);

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  stringifySearch: stringifyNavSearch,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
